import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import FileUpload from './components/FileUpload';
import SalesEntryForm from './components/SalesEntryForm';
import AnalyticsChat from './components/AnalyticsChat';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

function App() {
  const [activeTab, setActiveTab] = useState('sales');
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);

  const fetchProducts = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/sales/products`);
      if (response.ok) {
        const data = await response.json();
        setProducts(data.products);
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setProductsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Haus of Lush <span className="brand-sub">alchemists</span></h1>
        <nav className="App-nav">
          <button
            className={`nav-tab ${activeTab === 'sales' ? 'active' : ''}`}
            onClick={() => setActiveTab('sales')}
          >
            Sales Entry
          </button>
          <button
            className={`nav-tab ${activeTab === 'analytics' ? 'active' : ''}`}
            onClick={() => setActiveTab('analytics')}
          >
            Analytics
          </button>
        </nav>
      </header>
      <main className="App-main">
        {activeTab === 'sales' && <SalesEntryForm products={products} productsLoading={productsLoading} />}
        {activeTab === 'analytics' && <AnalyticsChat />}
      </main>
    </div>
  );
}

export default App;
